/**
* 单任务在班级内的详情
*/
<template>
    <span>
        <a @click="openmodel()">详情</a>
        <a-modal :visible="visible" :width="1280" destroyOnClose title="章节作业完成情况" @ok="okmodel" @cancel="cancelmodel">
		<!-- {{itemdata}} -->
		
		<!-- {{tabledata}} -->
         
            <div>
                
				 <table>
				    <thead>
				      <tr>
						<th class="tableth" >姓名</th>
				        <th class="tableth" v-for="column in columns" :key="column">{{ column['missiontypename']}}</th>
				      </tr>
				    </thead>
				    <tbody>
				      <tr v-for="row in tabledata" :key="row.user.org_user_id">
						 <td class="tabletd">{{row.user.user_name}}</td>
				       <td class="tabletd" :class="'tdback'+getProblemIsRight(row, index)" v-for="(column,index) in columns" :key="column">{{tihuan(getProblemIsRight(row, index))}}</td>
						<!-- <td class="tabletd"  v-for="(column,index) in columns" :key="column">{{getProblemIsRight(row, index)}}</td> -->
						
					  </tr>
				    </tbody>
				  </table>
                <div>总共{{ pageinfo.total }}条数据</div>
                <a-switch size="small" v-model="showcount" @change="getshowcount" />
            </div>
          
        </a-modal>
    </span>
</template>
<script>
//   import  squadusermodel from '@/views/orgpublish/squadusermodel.vue';

export default {
    
    props: {
        itemdata: {},
        squad_id: undefined,
        mission_id: undefined
    },
    data() {
        return {
            data: [],
            pageinfo: {
                total: 1,
                current: 1,
                pageSize: 10
            },
			columns:[],
            showcount: false,
            tabledata: [],
            loading: false,
            visible: false,
            squadinfo: [],
            missioninfo: [],
            usermission: [],
            questionList: [],
        };
    },
    mounted() {

    },
    computed: {

    },
    methods: {

       
        getshowcount() {
            if (this.showcount) {
                this.pageinfo.pageSize = 9999;
                this.pageinfo.current = 1;
                // this.showcount=true;
            }
            if (!this.showcount) {
                this.pageinfo.pageSize = 10;
                this.pageinfo.current = 1;
                // this.showcount=false;
            }
            this.getTableList();
        },
		
		
       
        getTableList() {
            this.loading = true;
            this.$axios
                .post("/api/OrgSquad/getchaptertongjiinfo", {
                    data: {
                        squad_id: this.itemdata.squad_id,
                        chapter_id: this.itemdata.id
                    },
                    pageinfo: this.pageinfo
                })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                        this.tabledata = null;
                    } else {
                        this.tabledata = res.data['tr'];
						this.columns=res.data['td']
                      //  this.pageinfo = res.data.pageinfo;
                    }
                })
                .catch(err => {
                    console.error(err);
                }).finally(() => {
                    this.loading = false;
                })
        },

        openmodel() {
            this.visible = true;
            // this.getmissioninfo();
            // this.getsquadinfo();
             this.getTableList();
        },
		getProblemIsRight(row, colIndex) {
			//colIndex;
			//return row.problems;
		      if (row.problems && row.problems.length > 0) {
		        const problem = row.problems[colIndex];
				
		        if (problem) {
					
					if(problem.tj_time>0)
					{
						if(problem.correct==1)
						{
					return problem.isright;
						}
						else{
							return 2;
						}
					}
					else{
						return 3;
					}
		        }
				
		      }
		      
		    },
		tihuan(xx)
			{
				if(xx==0)
				{
					return "✗"
				}
				if(xx==1)
				{
					return "✓"
				}
				if(xx==2)
				{
					return "未批改"
				}
				if(xx==3)
				{
					return "未完成"
				}
				
			},
        okmodel() {
            this.visible = false;
        },
        cancelmodel() {
            this.visible = false;
        },

        onPaginationChange(item) {
            this.pageinfo.current = item.current;
            this.getTableList();
        },


    }
};
</script>
<style>
.active_btn {
    margin-left: 5px;
}
.tableth {
    width: 100px; /* 设置宽度 */
    height: 50px; /* 设置高度 */
    border: 1px solid black; /* 设置边框样式 */
	text-align: center; 
  }
.tabletd {
      width: 100px; /* 设置宽度 */
      height: 50px; /* 设置高度 */
      border: 1px solid black; /* 设置边框样式 */
	  text-align: center; 
 }
 .tdback0
 {
  background-color: red;	 
 }
 .tdback2
 {
  background-color: green; /* 设置背景颜色为绿色 */	 
 }
 .tdback3
 {
  background-color: yellow;/* 设置背景颜色为绿色 */	 
 }
</style>
